export default {

  percentSold: { label: '% Sold', prefix: '', suffix: '%' },
  unitsLeft: { label: 'Units Left', prefix: '', suffix: '', format: '0' },
  // projectStatus: { label: 'Project Status', prefix: '', suffix: '' },
  // constructionStatus: { label: 'Construction Status', prefix: '', suffix: '' },
  absorptionRateAll: { label: 'Absorption Rate / Quarter', prefix: '', suffix: '%', format: '0.00' },
  absorptionRateLastQ: { label: 'Absorption Rate Last Quarter', prefix: '', suffix: '%', format: '0.00' },
  estimateTimeToDairn: { label: 'Estimate Time to Dairn ( Month )', prefix: '', suffix: '', format: '0.00' },

  startingResalePrice: { label: 'Avg. Resale Package (For Sale)', prefix: '', suffix: '', format: '0.00a' },
  resalePriceSqm: { label: 'Avg. Resale Price /sq.m. (For Sale)', prefix: '', suffix: '', format: '0.00a' },
  rentalPrice: { label: 'Avg. Rental Package (For Rent)', prefix: '', suffix: '', format: '0.00a' },
  rentalPriceSqm: { label: 'Avg. Rental Price /sq.m. (For Rent)', prefix: '', suffix: '', format: '0.00a' },
  capitalGain: { label: 'Cap. Gain', prefix: '', suffix: '', format: '0.00a' },
  rentalYield: { label: 'Rental Yield', prefix: '', suffix: '%' },

  launchPriceSqm: { label: 'Average of Launch Price', prefix: '', suffix: '', format: '0.00a' },
  startingPrice: { label: 'Starting Package (Project)', prefix: '', suffix: '', format: '0.00a' },
  startingCurrentPrice: { label: 'Starting Current Package (Project)', prefix: '', suffix: 'm', format: '0.00a' },
  currentPriceSqm: { label: 'Current Price / sq.m.', prefix: '', suffix: '', format: '0.00a' },

  // 'salePrice': { label: 'Sale Price', prefix: '', format: '0,0a' },
  // 'capitalGain': { label: 'Capital Gain', prefix: '', format: '0.00%' },
  // 'startingPrice': { label: 'Starting Price', prefix: '', format: '0,0a', suffix: 'm' },
  // 'rentalPrice': { label: 'Rent Price', prefix: '', format: '0,0.00' },
  // 'rentalYield': { label: 'Rental Yield', prefix: '', format: '0.00%' },
  // 'facilityScore': { label: 'Facility Score', prefix: '', format: '0.00%' },
}


// WEBPACK FOOTER //
// ./src/constants/analysis.js